import React from 'react';
import '../../../styles/components/KnowledgeCentre/KnowledgeCentre.scss';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ShareIcon from '@mui/icons-material/Share';
import Card from '@mui/material/Card';
import { VIEW_TYPES, ANALYTICS_EVENTS } from '../../../constants/MitraContentConstants';
import useMoengage from '../../../hooks/useMoengage';

const IframeView = props => {
  const { frame, likedItems, getUpdatedSelectedLikeButton, handleClickShare } = props;
  const [, , triggerContentInteractedEvent] = useMoengage();
  
  let eventTriggered;
  if (frame.id === '2') {
    eventTriggered = ANALYTICS_EVENTS.DYNAMIC_VIDEO_LIKE_BUTTON_CLICK;
  } else {
    eventTriggered = ANALYTICS_EVENTS.GAME_LIKE_BUTTON_CLICK;
  }

  return (
    <div
      style={{
        marginTop: '50px',
      }}
    >
      <Card sx={{ maxWidth: '100%' }}>
        <iframe
          style={{ width: 'inherit', height: '700px' }}
          className="iframe-tag"
          src={frame.url}
          frameBorder="0"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          allowFullScreen
        />

        <CardActions
          style={{
            marginTop: '-10px',
            float: 'right',
          }}
        >
          <IconButton
            aria-label="like"
            style={{ color: likedItems.includes(frame.id) ? 'orange' : 'black' }}
            onClick={() => {
              triggerContentInteractedEvent(eventTriggered, {
                content_url:frame.url,
                container_position: frame.containerPosition,
              });
              getUpdatedSelectedLikeButton(frame.id);
            }}
          >
            <ThumbUpIcon />
          </IconButton>

          <IconButton
            aria-label="share"
            style={{ color: 'black' }}
            color="primary"
            onClick={() => {
              handleClickShare(frame, VIEW_TYPES.IFRAME);
            }}
          >
            <ShareIcon />
          </IconButton>
        </CardActions>
      </Card>
    </div>
  );
};

export default IframeView;
